/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PresignPackageImageRequest interface.
 */
export function instanceOfPresignPackageImageRequest(value) {
    if (!('contentType' in value) || value['contentType'] === undefined)
        return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined)
        return false;
    return true;
}
export function PresignPackageImageRequestFromJSON(json) {
    return PresignPackageImageRequestFromJSONTyped(json, false);
}
export function PresignPackageImageRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contentType': json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'],
    };
}
export function PresignPackageImageRequestToJSON(json) {
    return PresignPackageImageRequestToJSONTyped(json, false);
}
export function PresignPackageImageRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
    };
}
